import { Flex, Table } from 'modules/ui';
import { FormSectionTitle } from 'modules/ui/form';
import { InfoOverview } from 'modules/ui/infoOverview';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import {
  StyledLeasingType,
  StyledLeasingTypeContainer,
  StyledOfferOverviewTextContainer,
  StyledText,
} from './styled';
import { useOfferOverviewActions } from './useOfferOverviewActions';
import { LeasingOfferDetails } from '../../../types/LeasingOffer';

export interface OfferOverviewProps {
  offerOverviewData?: LeasingOfferDetails;
}

export const OfferOverviewTab: FC<OfferOverviewProps> = ({
  offerOverviewData,
}) => {
  const { t } = useTranslation();

  const {
    titleText,
    leasingObjectDetails,
    overviewTableColumns,
    offerOverviewTableObjects,
    overallLeasingPaymentDetails,
    leasingPaymentDetails,
    offerContentData,
  } = useOfferOverviewActions(offerOverviewData);

  return (
    <Flex flexDirection="column" maxWidth="55rem">
      <StyledLeasingTypeContainer>
        <StyledLeasingType> {titleText.leasingTypeTitle}</StyledLeasingType>
      </StyledLeasingTypeContainer>
      <InfoOverview items={leasingObjectDetails} />

      <Flex width="100%" margin="3.125rem 0">
        <Table
          columns={overviewTableColumns}
          rows={offerOverviewTableObjects}
        />
      </Flex>

      <FormSectionTitle>
        {t('leasingOfferOverviewPage.offerOverviewTab.offerTitle')}
      </FormSectionTitle>

      <InfoOverview items={leasingPaymentDetails} />

      <InfoOverview items={overallLeasingPaymentDetails} />

      <StyledOfferOverviewTextContainer>
        {offerContentData.map((item) => (
          <StyledText key={item.key}>{item.value}</StyledText>
        ))}
      </StyledOfferOverviewTextContainer>
    </Flex>
  );
};
